import { Button, message, Modal, Tooltip } from 'antd';
import { Check, Files } from 'lucide-react';

interface PasswordModalProps {
  isPasswordModalVisible: boolean;
  generatedPassword: string;
  copied: boolean;
  setCopied: React.Dispatch<React.SetStateAction<boolean>>;
  setIsPasswordModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const PasswordModal = ({
  isPasswordModalVisible,
  generatedPassword,
  copied,
  setCopied,
  setIsPasswordModalVisible,
}: PasswordModalProps) => {
  const handlePasswordModalClose = () => {
    setIsPasswordModalVisible(false);
    setCopied(false);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedPassword).then(
      () => {
        setCopied(true);
        message.success('Password copied to clipboard');

        // Reset copy status after 3 seconds
        setTimeout(() => {
          setCopied(false);
        }, 3000);
      },
      () => {
        message.error('Failed to copy password');
      }
    );
  };
  return (
    <Modal
      title="User Created Successfully"
      open={isPasswordModalVisible}
      onCancel={handlePasswordModalClose}
      footer={[
        <Button
          key="close"
          type="primary"
          onClick={handlePasswordModalClose}
        >
          Close
        </Button>,
      ]}
    >
      <div className="mt-4">
        <p className="mb-2">An account has been created with an auto-generated password:</p>
        <div className="flex items-center bg-gray-100 !p-3 rounded-md">
          <span className="flex-grow font-mono">{generatedPassword}</span>
          <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
            <Button
              type="text"
              icon={copied ? <Check className="text-[#2C5F34]" /> : <Files  />}
              onClick={copyToClipboard}
            />
          </Tooltip>
        </div>
        <p className="mt-4 text-red-500">
          Please copy this password now. It will not be shown again.
        </p>
      </div>
    </Modal>
  );
};

export default PasswordModal;
